import { WorkingPage } from "../../../layouts/NotData";

const DomainWebsiteTab = () => {
  return <WorkingPage />;
};

export default DomainWebsiteTab;
